import api from './api'
import { API_ENDPOINTS } from '../config/api'

const posterService = {
  get: async () => {
    const response = await api.get(API_ENDPOINTS.POSTER.GET)
    return response.data
  },
  update: async (data) => {
    const response = await api.put(API_ENDPOINTS.POSTER.UPDATE, data)
    return response.data
  },
}

export default posterService
